import React, { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import Header from "../components/Header";
import { CgSpinner } from "react-icons/cg";
import { useNavigate } from "react-router-dom";
import axios from "../utils/axiosConfig";
import SellerReport from "../components/SellerReport";

const SellerReportPage = () => {
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  const [userData, setUserData] = useState({
    name: "",
    role: "",
    lastLogin: "",
    companyName: "",
  });

  useEffect(() => {
    console.log("Header useEffect triggered"); // Log to check if useEffect is triggered

    const fetchUserData = async () => {
      try {
        const response = await axios.get("/protected");
        const { name, role, last_login, company_name } = response.data;
        setUserData({
          name,
          role,
          lastLogin: last_login,
          companyName: company_name,
        });
        setIsLoading(false);
        console.log("User Data fetched:", response.data); // Log fetched data
      } catch (error) {
        console.error("Error fetching user data:", error);
        navigate("/login");
      }
    };

    fetchUserData();
  }, [navigate]);

  return (
    <div className="flex bg-gray-100 min-h-screen">
      <Sidebar userData={userData} />
      <div className="flex-1">
        {isLoading ? (
          <div className="flex justify-center items-center h-full">
            <CgSpinner className="animate-spin text-4xl" />
          </div>
        ) : (
          <>
            <Header userData={userData} />
            <div className="p-6">
              <SellerReport />
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default SellerReportPage;
